/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerLocationZipCodes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Location Zip Codes
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, May 14, 2019 - 04:49:33 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      05/14/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    LOCATIONZIPCODE_LIST_CONTAINER_LOADED,
    LOCATIONZIPCODE_LIST_CONTAINER_UNLOADED,
    LOCATIONZIPCODE_LIST_TABLE_LOADED,
    LOCATIONZIPCODE_LIST_TABLE_UNLOADED,

    LOCATIONZIPCODE_LIST_CHANGE_GROUP,

    LOCATIONZIPCODE_SELECT_ROW,
    LOCATIONZIPCODE_ADD,
    LOCATIONZIPCODE_EDIT,
    LOCATIONZIPCODE_DELETE,
    LOCATIONZIPCODE_OPEN_WARNING,
    LOCATIONZIPCODE_CLOSE_WARNING,
    LOCATIONZIPCODE_DELETE_DISABLE,

    LOCATIONZIPCODE_EDIT_CONTAINER_LOADED,
    LOCATIONZIPCODE_EDIT_CONTAINER_UNLOADED,
    LOCATIONZIPCODE_EDIT_FORM_LOADED,
    LOCATIONZIPCODE_EDIT_FORM_UNLOADED,
    LOCATIONZIPCODE_EDIT_DATA_LOAD,
    LOCATIONZIPCODE_EDIT_CONTAINER_SUBMIT,
    LOCATIONZIPCODE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeLocationZipCodes';

const defaultState = {
    refreshList: false,
    danger: false,
    locationzipcodeid: 0,
    countryid: 0,
    country: '',
    stateid: 0,
    state: '',
    countyid: 0,
    county: '',
    zipcode: '',
    city: '',
    latitude: '',
    longitude: '',
    gmtid: 0,
    dstid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case LOCATIONZIPCODE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                locationzipcodes: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
                counties: action.payload[3] ? action.payload[3].records : null
            }
        case LOCATIONZIPCODE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case LOCATIONZIPCODE_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case LOCATIONZIPCODE_SELECT_ROW:
            return {
                ...state,
                locationzipcodeid: action.id
            }
        case LOCATIONZIPCODE_ADD:
            return {
                ...state
            }
        case LOCATIONZIPCODE_EDIT:
            return {
                ...state,
                locationzipcodeid: action.id
            }
        case LOCATIONZIPCODE_DELETE:
            return {
                ...state,
                locationzipcodeid: null
            }
        case LOCATIONZIPCODE_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case LOCATIONZIPCODE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case LOCATIONZIPCODE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case LOCATIONZIPCODE_EDIT_CONTAINER_LOADED:
        case LOCATIONZIPCODE_EDIT_DATA_LOAD:
            return {
                ...state,
                locationzipcodeid: action.payload[0] ? action.payload[0].locationzipcodeid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                countyid: action.payload[0] ? action.payload[0].countyid : 0,
                county: action.payload[3] ? action.payload[3].name : action.payload[0] ? action.payload[0].county : '',
                zipcode: action.payload[0] ? action.payload[0].zipcode : '',
                city: action.payload[0] ? action.payload[0].city : '',
                latitude: action.payload[0] ? action.payload[0].latitude : '',
                longitude: action.payload[0] ? action.payload[0].longitude : '',
                gmtid: action.payload[0] ? action.payload[0].gmtid : 0,
                dstid: action.payload[0] ? action.payload[0].dstid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case LOCATIONZIPCODE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case LOCATIONZIPCODE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case LOCATIONZIPCODE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case LOCATIONZIPCODE_LIST_CONTAINER_UNLOADED:
        case LOCATIONZIPCODE_LIST_TABLE_UNLOADED:
        case LOCATIONZIPCODE_EDIT_CONTAINER_UNLOADED:
        case LOCATIONZIPCODE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerLocationZipCodes.js